import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable';
import { global, globalEpics, initialGlobalState } from '../domains/global/redux';
import { referral, referralEpics, initialReferralState } from '../domains/referral/redux';
import { referralList, referralListEpics, initialReferralListState } from '../domains/referralList/redux';
import { session, sessionEpics, initialSessionState, sessionActionTypes } from '../domains/session/redux';
import { users, usersEpics, initialUsersState } from '../domains/users/redux';
import { careUnit, careUnitEpics, initialCareUnitState } from '../domains/careUnit/redux';
import { optician, opticianEpics, initialOpticianState } from '../domains/optician/redux';
import { eventLog, eventEpics, initialEventState } from '../domains/eventLog/redux';
import {
  organizations,
  organizationsEpics,
  initialOrganizationsState,
} from "../domains/organization/redux";
import {
  report,
  reportOptionEpic,
  initialReportState,
} from "../domains/report/redux";
import { terms, termsEpics, initialTermsState } from '../domains/terms/redux';

export const rootEpic = combineEpics(
    sessionEpics,
    globalEpics,
    referralEpics,
    referralListEpics,
    usersEpics,
    careUnitEpics,
    opticianEpics,
    eventEpics,
    organizationsEpics,
    reportOptionEpic,
    termsEpics
);

export const appReducer = combineReducers({
    session,
    global,
    referral,
    referralList,
    users,
    optician,
    careUnit,
    eventLog,
    organizations,
    report,
    terms,
});

export const rootReducer = (state, action) => {
    if (action.type === sessionActionTypes.LOG_OUT_SUCCESS) {
        console.log('Resetting all state')
        state = {
            global: initialGlobalState(),
            session: initialSessionState(),
            users: initialUsersState(),
            careUnit: initialCareUnitState(),
            optician: initialOpticianState(),
            referral: initialReferralState(),
            referralList: initialReferralListState(),
            eventLog: initialEventState(),
            organizations: initialOrganizationsState(),
            report: initialReportState(),
            terms: initialTermsState()
        };
    }
    return appReducer(state, action);
}